export const SECONDARY_SALE_ORDER = {
    BASE_PATH: '/secondary-sale-order/sale-order/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    CONVERT_TO_INVOICE_PATH(id: string | number) {
        return this.BASE_PATH + `${id}` + '/edit/convert-to-invoice';
    },
    ADD_BUTTON_TITLE: 'Add New Secondary Sale Order',
    ADD_PAGE_TITLE: 'Add New Secondary Sale Order',
    LIST_PAGE_TITLE: 'Secondary Sale Order List',
    EDIT_PAGE_TITLE: 'Edit Secondary Sale Order',
    GET_ALL: 'secondary-sale-order/sale-order',
    GET_ALL_APPROVAL: 'secondary-sale-order/sale-order-approval',
    GET_ONE: 'secondary-sale-order/sale-order/edit/',
    CREATE: 'secondary-sale-order/sale-order',
    UPDATE: 'secondary-sale-order/sale-order/update/',
    DELETE: 'secondary-sale-order/sale-order/delete/',
    APPROVE: 'secondary-sale-order/order-approval/update/',
};
